import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import ModalOverlay from "../modalOverlay/ModalOverlay";
import modalStyles from "./modal.module.css";
import i18n from "../../../i18n";

interface IModal {
  children: ReactNode;
  onClose: () => void;
  prevencherAnswer?: boolean;
  /** When false, only overlay click closes (e.g. child has its own close UI). */
  showCloseButton?: boolean;
}
const Modal: React.FC<IModal> = ({
  children,
  onClose,
  prevencherAnswer,
  showCloseButton = true,
}: IModal) => {
  const modalRoot = document.getElementById("modals") as HTMLDivElement;

  return ReactDOM.createPortal(
    <>
      <div dir={i18n.dir()}
        className={`${modalStyles.popupWindow} ${
          prevencherAnswer && modalStyles.popupWindow_type_wide
        }`}
      >
        {showCloseButton ? (
          <button
            className={modalStyles.popupWindow__closeBtn}
            onClick={onClose}
            type="button"
          />
        ) : null}
        {children}
      </div>
      <ModalOverlay onClick={onClose} />
    </>,
    modalRoot
  );
};

export default Modal;
